export { default } from './Typography'
